import { LogoHeader } from "@/components/logoHeader";
import { BackgroundImage } from "@/components/backgroundImage"
import { ViewForm } from "@/components/viewForm";


function RecuperarSenha() {

  return (
    <div className="mx-auto max-w-[500px] min-h-screen px-2 pb-8">
      <LogoHeader />
        <BackgroundImage height="h-[300px]" alt="Duplicate-amico.png" src="/assets/Duplicate-amico.png" /> 
        <p className="text-2xl font-bold text-center">
          Recuperação de Senha
          </p>
           <ViewForm components={ [
          {
          id: "cpf",
          label: "CPF",
          helpText: "",
          component: "InputCPF",
          type: "text",
          defaultValue: "",
          }, 
          {id: "data_nascimento",
          label: "Data de nascimento",
          helpText: "",
          component: "InputData",
          type: "tel",
          defaultValue: "",
        },
        {
          id: "",
          label: "Enviar",
          helpText: "",
          type: "button-submit",
          component: "ButtonSubmit",
        },
      ]} 
        backPage="/setor/" 
        initialValues={{ cpf: "" }} 
        recuperarSenha={true} />

      </div>
    
  )
}

export default RecuperarSenha;